import * as React from "react";

export interface INavigationSiteLogoProps {
    logoSrc: string;
    logoAlt: string;
    logoLinkUrl: string;
}

const NavigationSiteLogo: React.SFC<INavigationSiteLogoProps> = props => {
    return (
        <a className="navigation-site-logo__link" href={props.logoLinkUrl}>
            <img className="navigation-site-logo__img" src={props.logoSrc} alt={props.logoAlt} />
        </a>
    );
};

export default NavigationSiteLogo;
